<ng-container *ngIf="releaseDate | releaseIsNotPublicPipe; else releaseDatePublic">
    <span class="badge bg-light text-dark border w-100 fw-light"
          style="font-size: 11px"
          [stickyPopover]="popContent"
          [popoverTitle]="popTitle"
          [autoClose]="'outside'"
          [animation]="false"
          [ngClass]="(releaseDate | releaseIsNotPublicPipe) ? 'border-danger' : 'border-dark'"
          [openDelay]="300"
          popoverClass='release-date-popover'
          container="body"
          triggers="manual">
      {{releaseDate | releaseDate}}
    </span>
</ng-container>

<ng-template #popTitle>
  <i class="fa-light fa-calendar me-1"></i>Release date
</ng-template>

<ng-template #popContent>
  <ng-container [ngSwitch]="releaseDate | releaseDate">
    <ng-container *ngSwitchCase="'In QA3'">
      Data are in quality assessment after a problem was detected
    </ng-container>
    <ng-container *ngSwitchCase="'In progress'">
      Data are waiting to be assessed and delivered
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="btn-group-vertical btn-group-sm w-100">
        <button *ngFor="let calendarExporter of calendarExporters"
                class="btn btn-light"
                (click)="exportCalendar(calendarExporter)">
          <i class="{{calendarExporter.icon}} me-1"></i>{{calendarExporter.label}}
        </button>
      </div>
      <div class="text-muted mt-2" style="max-width: 10rem">
        These data are not yet public. If you want to be reminded when these data reach the end of their proprietary
        period, click on one the buttons to add an event to your calendar application.
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #releaseDatePublic>
  <span class="badge bg-light text-dark border border-dark w-100 fw-light"
        style="font-size: 11px">
   {{releaseDate| releaseDate}}
  </span>
</ng-template>
